import { countries } from '@umahealth/entities'

export const isCountry = (country: countries) => {
	return process.env.NEXT_PUBLIC_COUNTRY === country
}